import axios from 'axios';

import { API_BASE_URL } from '@/config';

// 创建 Axios 实例
const api = axios.create({
    baseURL: `${API_BASE_URL}/api`,
    timeout: 30000, // 30秒超时
});

// 设置请求拦截器以自动添加 token
api.interceptors.request.use( // 使用 `api` 而不是 `instance`
    config => {
        const token = localStorage.getItem('token'); // 获取 token 可以直接从 localStorage
        if (token) {
            config.headers.token = token; // 使用 'token' 作为 header 名称
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

api.interceptors.response.use(
    response => {
        // blob 响应（文件下载）跳过 code 检查，直接返回 response
        if (response.config.responseType === 'blob') {
            return response;
        }
        const res = response.data;
        if (res.code !== 200) {
            alert(res.msg || '系统错误');
            if (res.code === 1001) { // 假设 1001 表示未认证或 token 过期
                localStorage.removeItem('token');
                window.location.href = '/login';
            }
            return Promise.reject(new Error(res.msg || 'Error'));
        }
        return res;
    },
    error => {
        console.error('响应错误:', error);
        alert('网络错误，请稍后重试');
        return Promise.reject(error);
    }
);


// 导出 `api` 实例供其他模块使用
export default api;
